import { render, staticRenderFns } from "./weekly-sales.vue?vue&type=template&id=165fd60e&scoped=true&"
import script from "./weekly-sales.vue?vue&type=script&lang=js&"
export * from "./weekly-sales.vue?vue&type=script&lang=js&"
import style0 from "./weekly-sales.vue?vue&type=style&index=0&id=165fd60e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165fd60e",
  null
  
)

export default component.exports